"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _UISection = _interopRequireDefault(require("../section/UISection"));

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var _iconName = require("../utils/propTypes/iconName");

var _BrowserTest = require("../utils/BrowserTest");

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

var _theme = require("HubStyleTokens/theme");

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding-right: ", ";\n  padding-bottom: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  min-height: ", ";\n  flex-direction: ", ";\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 24px ", "px;\n\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  img {\n    max-width: ", "px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  border: ", ";\n  border-radius: 4px;\n  color: ", ";\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var CONTENT_PADDING_X = 20;
var STYLES_FOR_USE = {
  hover: {
    backgroundColor: _colors.CALYPSO_LIGHT,
    border: "1px dashed " + _colors.CALYPSO,
    iconColor: _theme.BASE_LINK_COLOR
  },
  processing: {
    border: "1px solid " + _colors.GYPSUM,
    iconColor: _colors.EERIE
  },
  selected: {
    border: "1px solid " + _colors.GYPSUM,
    color: _colors.OBSIDIAN,
    iconColor: _colors.OBSIDIAN
  },
  error: {
    backgroundColor: _colors.CANDY_APPLE_LIGHT,
    border: "1px dashed " + _colors.CANDY_APPLE_DARK,
    color: _theme.BASE_FONT_COLOR,
    iconColor: _colors.CANDY_APPLE_DARK
  },
  success: {
    backgroundColor: _colors.OZ_LIGHT,
    border: "1px dashed " + _colors.OZ_DARK,
    color: _theme.BASE_FONT_COLOR,
    iconColor: _colors.OZ
  }
};
var Outer = (0, _styledComponents.default)(function (props) {
  var __variantStyles = props.variantStyles,
      rest = (0, _objectWithoutProperties2.default)(props, ["variantStyles"]);
  return _react.default.createElement(_UISection.default, rest);
}).withConfig({
  displayName: "UIDropZone__Outer",
  componentId: "sc-1eb8o77-0"
})(_templateObject(), function (_ref) {
  var variantStyles = _ref.variantStyles;
  return variantStyles.backgroundColor || _colors.GYPSUM;
}, function (_ref2) {
  var variantStyles = _ref2.variantStyles;
  return variantStyles.border || "1px dashed " + _colors.SLINKY;
}, function (_ref3) {
  var variantStyles = _ref3.variantStyles;
  return variantStyles.color || _colors.EERIE;
}); // Fix for #6763: Under IE11, images don't respect `max-width: 100%` in this flex container.

var imgWidthMixin = (0, _styledComponents.css)(_templateObject2(), function (_ref4) {
  var contentWidth = _ref4.contentWidth;
  return contentWidth - CONTENT_PADDING_X * 2;
});

var Content = _styledComponents.default.div.withConfig({
  displayName: "UIDropZone__Content",
  componentId: "sc-1eb8o77-1"
})(_templateObject3(), function (_ref5) {
  var size = _ref5.size;
  return size === 'small' ? _sizes.DROP_SMALL_HEIGHT : _sizes.DROP_LARGE_HEIGHT;
}, function (_ref6) {
  var size = _ref6.size;
  return size === 'small' ? 'row' : 'column';
}, CONTENT_PADDING_X, function (_ref7) {
  var contentWidth = _ref7.contentWidth;
  return contentWidth && imgWidthMixin;
});

var Icon = (0, _styledComponents.default)(function (props) {
  var __dropSize = props.dropSize,
      rest = (0, _objectWithoutProperties2.default)(props, ["dropSize"]);
  return _react.default.createElement(_UIIcon.default, rest);
}).withConfig({
  displayName: "UIDropZone__Icon",
  componentId: "sc-1eb8o77-2"
})(_templateObject4(), function (_ref8) {
  var dropSize = _ref8.dropSize;
  return dropSize === 'small' && '12px';
}, function (_ref9) {
  var dropSize = _ref9.dropSize;
  return dropSize === 'large' && '16px';
});

var Body = _styledComponents.default.div.withConfig({
  displayName: "UIDropZone__Body",
  componentId: "sc-1eb8o77-3"
})(_templateObject5());

var emptyObject = {};

var UIDropZone = _react.default.createClass({
  displayName: "UIDropZone",
  propTypes: {
    children: _react.PropTypes.node,
    contentClassName: _react.PropTypes.string,
    iconName: (0, _iconName.getIconNamePropType)(),
    iconSize: _UIIcon.default.propTypes.size,
    size: (0, _tshirtSize.propTypeForSizes)(['sm', 'lg']).isRequired,
    use: _react.PropTypes.oneOf(['default', 'hover', 'processing', 'selected', 'error', 'success']).isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      size: 'small',
      use: 'default'
    };
  },
  getInitialState: function getInitialState() {
    return {
      contentWidth: null
    };
  },
  componentDidMount: function componentDidMount() {
    this.computeWidth();
  },
  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
    // ⚠️ This condition prevents infinite loops! ⚠️
    if (prevState.contentWidth === this.state.contentWidth) {
      this.computeWidth();
    }
  },
  computeWidth: function computeWidth() {
    if (!(0, _BrowserTest.isIE11)()) return;
    var contentWidth = this._contentEl.offsetWidth;

    if (contentWidth && contentWidth !== this.state.contentWidth) {
      this.setState({
        contentWidth: contentWidth
      });
    }
  },
  render: function render() {
    var _this = this;

    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        contentClassName = _this$props.contentClassName,
        iconName = _this$props.iconName,
        iconSize = _this$props.iconSize,
        size = _this$props.size,
        use = _this$props.use,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "contentClassName", "iconName", "iconSize", "size", "use"]);
    var contentWidth = this.state.contentWidth;
    var longhandSize = (0, _tshirtSize.toLonghandSize)(size);
    var computedClassName = (0, _classNames.default)('private-drop-zone', className, {
      'private-drop-zone--large': size === 'large'
    });
    var variantStyles = STYLES_FOR_USE[use] || emptyObject;
    return _react.default.createElement(Outer, (0, _extends2.default)({}, rest, {
      className: computedClassName,
      variantStyles: variantStyles
    }), _react.default.createElement(Content, {
      className: (0, _classNames.default)('private-drop-zone__content', contentClassName),
      innerRef: function innerRef(ref) {
        _this._contentEl = ref;
      },
      contentWidth: contentWidth,
      size: size
    }, iconName ? _react.default.createElement(Icon, {
      name: iconName,
      dropSize: longhandSize,
      size: iconSize || (longhandSize === 'small' ? 24 : 48),
      color: variantStyles.iconColor
    }) : null, _react.default.createElement(Body, null, children)));
  }
});

var _default = UIDropZone;
exports.default = _default;
module.exports = exports.default;